"use client";
import React, {useEffect} from "react";
import styled from "styled-components";
import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import InnerBanner from "@/components/InnerBanner";
import Calculator from "@/components/calculator/Calculator";
import UsingCalculator from "@/components/calculator/UsingCalculator";
import {getResearchApi} from "@/api";
import ResearchPortal from "@/components/research/ResearchPortal";



gsap.registerPlugin(SplitText);


const AllResearch = ({data,researchData}) => {

    const banner = data?.[0]?.banner


// split text
    useEffect(() => {
        document.fonts.ready.then(() => {
            gsap.utils.toArray(".split-up").forEach((item, i) => {
                // Store original HTML content and letter spacing
                const originalHTML = item.innerHTML;
                const originalLetterSpacing = window.getComputedStyle(item).letterSpacing;

                const parentSplit = new SplitText(item, {
                    linesClass: "split-parent",
                });

                new SplitText(item, {
                    type: "lines, chars",
                    linesClass: "split-child",
                });

                gsap.from(parentSplit.lines, {
                    duration: 1,
                    yPercent: 100,
                    // stagger: 0.1,
                    scrollTrigger: {
                        trigger: item,
                        start: "top 90%",
                        once: true
                    },
                    onComplete: () => {
                        // Remove the split-up class
                        item.classList.remove("split-up");

                        // Hide the element
                        item.style.visibility = "hidden";

                        // Revert HTML to original and apply original letter spacing
                        item.innerHTML = originalHTML;
                        item.style.letterSpacing = originalLetterSpacing;

                        // Show the element again
                        item.style.visibility = "visible";
                    }
                });
            });
        });
    }, [data,researchData]);


    return (
        <StyledComponent>
            <InnerBanner img={banner?.image ? banner?.image : '/images/static/blur_.jpg'}
                         subtitle={banner?.subtitle}
                         title={banner?.title}
                         text={banner?.desc}
            />
            <ResearchPortal data={researchData}/>
        </StyledComponent>
    );
};


const StyledComponent = styled.section`

`;

export default AllResearch;
